import { type MenuItem } from '@databases/contextual-menu/ContextualMenu';

import { addEntryBelowMenuItem } from '../menu-items/add-entry-below-menu-item.tsx';
import { addFieldRightMenuItem } from '../menu-items/add-field-right-menu-item.tsx';
import { askRovoMenuItem } from '../menu-items/ask-rovo-menu-item.tsx';
import { bulkEditValuesMenuItem } from '../menu-items/bulk-edit-values-menu-item.tsx';
import { clearValuesMenuItem } from '../menu-items/clear-values-menu-item.tsx';
import { commentsMenuItem } from '../menu-items/comments-menu-item.tsx';
import { copyValueLinkMenuItem } from '../menu-items/copy-value-link-menu-item.tsx';
import { deleteEntriesMenuItem } from '../menu-items/delete-entries-menu-item.tsx';
import { deleteFieldsMenuItem } from '../menu-items/delete-fields-menu-item.tsx';
import {
  type MenuItemBuilder,
  SELECT_VALUE_MENU_ACTIONS,
  type CellContextMenuContext
} from '../types.ts';

export type MenuItemMap = Partial<Record<SELECT_VALUE_MENU_ACTIONS, MenuItem>>;

/**
 * The registry contains a map of actions to item builders.
 * The ordering of this is not important as the firstMenuItems and secondMenuItems
 * define the place and ordering of items.
 */
const selectValueMenuItemsRegistry: {
  [key in SELECT_VALUE_MENU_ACTIONS]?: MenuItemBuilder;
} = {
  [SELECT_VALUE_MENU_ACTIONS.ADD_ENTRY_BELOW]: addEntryBelowMenuItem,
  [SELECT_VALUE_MENU_ACTIONS.ADD_FIELD_RIGHT]: addFieldRightMenuItem,
  [SELECT_VALUE_MENU_ACTIONS.ASK_ROVO]: askRovoMenuItem,
  [SELECT_VALUE_MENU_ACTIONS.BULK_EDIT_VALUES]: bulkEditValuesMenuItem,
  [SELECT_VALUE_MENU_ACTIONS.CLEAR_VALUES]: clearValuesMenuItem,
  [SELECT_VALUE_MENU_ACTIONS.COMMENTS]: commentsMenuItem,
  [SELECT_VALUE_MENU_ACTIONS.COPY_VALUE_LINK]: copyValueLinkMenuItem,
  [SELECT_VALUE_MENU_ACTIONS.DELETE_ENTRIES]: deleteEntriesMenuItem,
  [SELECT_VALUE_MENU_ACTIONS.DELETE_FIELDS]: deleteFieldsMenuItem
};

/**
 * Creates the currently available list of context menu items.
 */
export function createContextualMenuItems(context: CellContextMenuContext): MenuItemMap {
  const menuItems: MenuItemMap = {};
  const menuItemKeys = Object.keys(
    selectValueMenuItemsRegistry
  ) as SELECT_VALUE_MENU_ACTIONS[];

  menuItemKeys.forEach((key) => {
    const action = key as SELECT_VALUE_MENU_ACTIONS;
    // @ts-ignore this item is not null. we are looping over the keys
    const item = selectValueMenuItemsRegistry[action](context);

    if (item.isEnabled()) {
      menuItems[action] = item.menuItem;
    }
  });

  return menuItems;
}
